// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1blJe","boxTitle":"Qualiphy_boxTitle__2GoNf","box":"Qualiphy_box__7uHfD","toggleWrap":"Qualiphy_toggleWrap__YTuFg"};